<div class="divfilter"></div>
<app-patient-search
  [search]="patientSearchList"
  [refreshTime]="refreshTime"
  (onActionClick)="patientOnSelect($event)"

></app-patient-search>

<div class="patient-detail fixed-height" *ngIf="patientInfoDisplay">
  <img
    [style.width]="'30px'"
    [src]="patientImage ? patientImage : './assets/images/user.png'"
  />
  <label class="patient-name-label"> {{ patientInfoDisplay }}</label>
</div>

<br>
<div class="right">
  <button mat-mini-fab class="btnOrange" color="primary" matTooltip="{{ 'payerInfo.releasePatient' | translate }}" 
  (click)="convertToCTOSUnblock(false)">
    <mat-icon>swap_horiz</mat-icon>
  </button>
  &nbsp;
  <button mat-mini-fab class="btnRed" color="primary" matTooltip="{{ 'payerInfo.ctosBlockPatient' | translate }}" 
  (click)="convertToCTOSblock(true)">
    <mat-icon>block</mat-icon>
  </button>
  &nbsp;
  <button mat-mini-fab class="btnCyan" color="primary" matTooltip="{{ 'payerInfo.addPatient' | translate }}"
   (click)="routerToScreen()"> 
    <mat-icon>add_circle_outline</mat-icon>
  </button>
</div>

<mat-tab-group
  class="tabGroupPersonalDetails mx-2"
  [selectedIndex]="selected.value"
  (selectedIndexChange)="selected.setValue($event)"
>
  <!-- Patient Blocking Tab -->
  <mat-tab class="tabSubPersonalDetails">
    <ng-template mat-tab-label>
      <mat-icon>person_pin</mat-icon> &nbsp; {{ "RegistrationPage.patientBlocking" | translate }} &nbsp;
    </ng-template>
    <div class="table-height">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="mat-header mat-elevation-z8"
    >
      <ng-container matColumnDef="radio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row">
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group"
            [(ngModel)]="selectedPerson"
          >
            <mat-radio-button
              [value]="row"
              (click)="selectedRow(row)"
            ></mat-radio-button>
          </mat-radio-group>
        </td>
      </ng-container>

      <ng-container matColumnDef="patientDetails">
        <th mat-header-cell *matHeaderCellDef  class="custom-header">
          {{ "adt.genderAge" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" [ngClass]="{'vip-background': element.isVip}">
          <div class="cell-content">
            <img src="./assets/images/{{ generalApiService.getGenderValue(element.gender) }}" alt="image" class="patient-image" />
            <div class="patient-details">
              <strong class="Age-font">{{ element.patientAge }}</strong>
              <span>{{element.dob | date :"dd/MM/yyyy"}}  {{ generalApiService.getGender(element.gender) }}</span>
            </div>
          </div>
        </td>            
      </ng-container>

      <ng-container matColumnDef="mrn">
        <th mat-header-cell *matHeaderCellDef  class="custom-header">
          {{ "EncounterPage.Patient" | translate }}
        </th>
        <td mat-cell class="col-nowrap" *matCellDef="let element" 
        [ngClass]="{
          'long-name': element.firstName.length > 25
        }"
        >
          <div>
            <div class="name-div">
            <strong class="name-container">{{ element.firstName }}</strong><br>
            </div>
            <span>{{ element.MRN }}</span>
          </div>
        </td>
      </ng-container>


      <!-- <ng-container matColumnDef="mrn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>MRN</th>
        <td mat-cell *matCellDef="let element">{{ element.MRN }}</td>
      </ng-container>

      <ng-container matColumnDef="patientDetails">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "billing.patientDetails" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
      </ng-container> -->


      <ng-container matColumnDef="identificationType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "RegistrationPage.primaryID" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="Age-font">{{ element.primaryIDdesc }}</span></td>
      </ng-container>


      <ng-container matColumnDef="identificationNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "RegistrationPage.primaryDocNo" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="Age-font">{{ element.primaryId }}</span></td>
      </ng-container>

      <ng-container matColumnDef="contactNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "billing.contactNumber" | translate }} 
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="Age-font">{{ element.phoneNumber }}</span></td>
      </ng-container>

      <ng-container matColumnDef="isCTOS">
        <th mat-header-cell *matHeaderCellDef>CTOS</th>
        <td mat-cell class="col-norwap center" *matCellDef="let element">
          <ng-container *ngIf="element.isCTOS; else falseIcon">
            <mat-icon class="green-icon">done</mat-icon>
          </ng-container>
          <ng-template #falseIcon>
            <mat-icon class="red-icon">clear</mat-icon>
          </ng-template>
        </td>
      </ng-container>


      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>   {{ "mrd.reason" | translate }} </th>
        <td mat-cell *matCellDef="let element">
          <span class="Age-font">{{ element.reason }}</span></td>
      </ng-container>


      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "mrd.remarks" | translate }}
        </th>
        <td 
          mat-cell 
          *matCellDef="let element" 
          [ngClass]="{ 'long-name': element.remarks?.length > 25 }"
        >
          <div class="name-div">
            <strong class="name-container">{{ element.remarks || '' }}</strong>
          </div>
        </td>
      </ng-container>


      <!-- <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "mrd.status" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.blockStatus }}</td>
      </ng-container> -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{ "EncounterListPage.status" | translate }}
        </th>
         <td mat-cell *matCellDef="let element">
           <span
            class="status-box"
            [ngStyle]="{ 'background-color': generalApiService.getstatusColor(element.blockStatus)?.backgroundColor }"
           >
           {{ generalApiService.getstatusColor(element.blockStatus)?.text }}
         </span> 
         </td>
      </ng-container>

      <ng-container matColumnDef="blockingBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "RegistrationPage.blockingBy" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <div>
            <span class="Age-font">{{ element.blockedBy }} </span><br>
            <span>{{element.blockedDate | date :"dd/MM/yyyy" }} </span>
          </div></td>
      </ng-container>

 
      <!-- <ng-container matColumnDef="blockingDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "RegistrationPage.blockingDate" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element.blockedDate | date :"dd/MM/yyyy"}}
        </td>
      </ng-container> -->


      <ng-container matColumnDef="history">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "RegistrationPage.blockingHistory" | translate }}
        </th>
        <td mat-cell *matCellDef="let row" style="text-align: center;">
          <button mat-mini-fab class="btnGrey" color="primary" (click)="showBlockingHistory(row)">
            <mat-icon>history</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>
<div>
</div>
  </mat-tab>

  
</mat-tab-group>
<div class="footer-container">
  <app-footer
  [showFooter]="true"
  [totalDataLength]="totalDataLength"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [paginatorOptions]="paginatorOptions"
  (pageChange)="getNext($event)"
  (refresh)="refreshSearch()">
  </app-footer>
  </div>


